import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CanActivate, Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { ServiceAccessEnableToggleService } from './service-access-enable-toggle.service';
import { AuthService } from '../common';

@Injectable()
export class ServiceAccessEnableGuardService implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly serviceAccessEnableToggleService: ServiceAccessEnableToggleService,
  ) {}
  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.serviceAccessEnableToggleService.serviceAccessEnableCheck(
      {
        supply_gate_city: this.authService.getUserInfo()?.city_id,
        country_code: this.authService.getUserInfo()?.city?.country?.code,
      }
    ).pipe(
      map((isAccessEnable: boolean) => {
        if (isAccessEnable) {
          this.router.navigate(['']);
          return false;
        }

        return true;
      }),
      catchError(() => {
        this.router.navigate(['']);
        return of(false)
      })
    );
  }
}